export const getGitProvider = (repoUrlString: string | undefined) => {
  if (repoUrlString === undefined || !repoUrlString) {
    return "unknown";
  }
  const repoUrl = new URL(repoUrlString);

  if (repoUrl.hostname.includes("github")) {
    return "github";
  } else if (repoUrl.hostname.includes("gitlab")) {
    return "gitlab";
  } else if (repoUrl.hostname.includes("bitbucket")) {
    return "bitbucket";
  } else {
    return "unknown";
  }
};
